import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";
import usePageTitle from "../../pageTitle";
import {
  Box,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
  Typography,
  Paper,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  Icon,
  Divider,
} from "@mui/material";

function SmmOrganisationProfileLinkingPage() {
  usePageTitle("Account Profile Link");

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [organisationInfo, setOrganisationInfo] = useState({});
  const [platforms, setPlatforms] = useState([]);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      return;
    }

    const fetchData = async () => {
      await axios
        .get(`sm/organisation/profile/link/${ref}/init.json`)
        .then((result) => {
          console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setOrganisationInfo(result.data.data.organisation);
            setPlatforms(result.data.data.platforms);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  async function getAuthUrl(code) {
    setShowLoading(true);
    await axios
      .get(`sm/organisation/profile/${ref}/${code}/auth.json`)
      .then((result) => {
        setShowLoading(false);
        console.log(result.data.data);
        if (result.data.status === "success") {
          window.open(result.data.data.auth_url, "_blank").focus();
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
          onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleClose}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {errorMsg}
          </Alert>
        </Snackbar>
      </Box>
      <Box
        mt={10}
        sx={{ width: "100%", maxWidth: "480px", margin: "55px auto" }}
      >
        <Paper elevation={3}>
          <Box p={3}>
            <Box align="center">
              <Typography variant="h6">{organisationInfo.title}</Typography>
            </Box>
            <Box mt={5} align="center">
              <Typography variant="body2" fontSize={14}>
                Connect your organisation's social media accounts.
                <br />
                By doing so, you grant {organisationInfo.title} access to post
                media content on your behalf.
              </Typography>
            </Box>
            <Box mt={5}>
              <Divider />
            </Box>
            <Box mt={5} mb={5}>
              {platforms.map((platform) => (
                <Box my={2}>
                  <ListItem>
                    <ListItemIcon>
                      <img
                        src={`${AppConfig.api_media_url}${platform.logo}`}
                        alt=""
                        width={24}
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Typography>{platform.title}</Typography>}
                    />
                    <Box>
                      <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={() => getAuthUrl(platform.reference)}
                        startIcon={<Icon>send</Icon>}
                      >
                        Link
                      </Button>
                    </Box>
                  </ListItem>
                </Box>
              ))}
            </Box>
          </Box>
        </Paper>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default SmmOrganisationProfileLinkingPage;
